import { Component, Input } from '@angular/core';
import { FinalSolutionTypesEnum } from "@app/ps/enums/final-solution-types.enum";

@Component({
  templateUrl: './occupations-change-final-solution-type-finish.component.html',
})
export class OccupationsChangeFinalSolutionTypeFinishComponent {
  @Input()
  data: any;
  @Input()
  newOperation: Function;
  @Input()
  goToList: Function;

  protected readonly FinalSolutionTypesEnum = FinalSolutionTypesEnum;
}
